import { NgModule } from '@angular/core';
import { PromptRegisterHoverPipe } from './prompt-register-hover-pipe.pipe';

@NgModule({
   declarations: [PromptRegisterHoverPipe],
   exports: [PromptRegisterHoverPipe],
})
export class PromptRegisterHoverPipeModule {}